/**
 * @license
 * Copyright 厦门乾元盛世科技有限公司 All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file.
 */



import { Component, Input, ElementRef, Renderer, HostBinding, ViewEncapsulation } from '@angular/core';
import { ContentChildren, QueryList } from '@angular/core';

import classNames from 'classnames';

import { Option } from './option';
export class OptionGroup {
public isSelectOptGroup = true;
/**
 * 菜单样式前缀
 */
prefixCls = 'ant-select-dropdown-menu';
/**
 * Label
 */
label: string;
public disabled = true;
public _options: QueryList<Option>;
public options: Option[] = [];
/**
 * @param {?} renderer
 * @param {?} elementRef
 */
constructor(
private renderer: Renderer,
private elementRef: ElementRef) {

    }
/**
 * 菜单样式
 * @return {?}
 */
get classes(): string {
        const /** @type {?} */ classes = classNames({
            [`${this.prefixCls}-item-group`]: 1
        });
        return classes;
    }
/**
 * @return {?}
 */
get titleClass(): string {
        return `${this.prefixCls}-item-group-title`;
    }
/**
 * @return {?}
 */
get listClass(): string {
        return `${this.prefixCls}-item-group-list`;
    }
/**
 * @return {?}
 */
getOptions(): Option[] {
        if (this._options.length) {
            return this._options.toArray();
        }
        return this.options;
    }
/**
 * @param {?} option
 * @return {?}
 */
pushOption(option: Option): void {
        this.options.push(option);
    }

static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
    selector: 'ant-option-group',
    template: `
        <div [class]="titleClass">{{label}}</div>
        <div [class]="listClass">
            <ng-content></ng-content>
        </div>
    `,
    encapsulation: ViewEncapsulation.None
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: Renderer, },
{type: ElementRef, },
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'prefixCls': [{ type: Input },],
'label': [{ type: Input },],
'_options': [{ type: ContentChildren, args: [Option, ] },],
'classes': [{ type: HostBinding, args: ['class', ] },],
};
}

function OptionGroup_tsickle_Closure_declarations() {
/** @type {?} */
OptionGroup.decorators;
/**
 * @nocollapse
 * @type {?}
 */
OptionGroup.ctorParameters;
/** @type {?} */
OptionGroup.propDecorators;
/** @type {?} */
OptionGroup.prototype.isSelectOptGroup;
/**
 * 菜单样式前缀
 * @type {?}
 */
OptionGroup.prototype.prefixCls;
/**
 * Label
 * @type {?}
 */
OptionGroup.prototype.label;
/** @type {?} */
OptionGroup.prototype.disabled;
/** @type {?} */
OptionGroup.prototype._options;
/** @type {?} */
OptionGroup.prototype.options;
/** @type {?} */
OptionGroup.prototype.renderer;
/** @type {?} */
OptionGroup.prototype.elementRef;
}



interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
